<template>
    <svg width="50px" height="50px" viewBox="0 0 1024 1024" class="icon" version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M828 386l-48-13 48-13 13-48 13 48 49 13-49 13-13 49-13-49zM876 439l-19-4 19-5 4-19 5 19 19 5-19 4-5 19-4-19z"
            fill="#FDCD60" />
        <path d="M184 774l-21-5 21-5 5-21 5 21 20 5-20 5-5 21-5-21z" fill="#FDCD60" />
        <path d="M173 210m-9 0a9 9 0 1 0 18 0 9 9 0 1 0-18 0Z" fill="#5546CB" />
        <path d="M833 879a25 25 0 1 1 25-25 25 25 0 0 1-25 25z m0-36a10 10 0 1 0 10 10 10 10 0 0 0-10-10z"
            fill="#5546CB" />
        <path
            d="M659 275l3 2v2h10c24 2 52 2 95 1h2c9 2 20-1 24-24a27 27 0 0 0-22-32h-11l-13 3v-9a27 27 0 0 0-54-7 28 28 0 0 0 0 6v12l-12-2h-1a27 27 0 0 0-21 49z"
            fill="#FFFFFF" />
        <path
            d="M645 289c5 10 19 11 26 12 24 2 52 2 96 1h7a35 35 0 0 0 25-10c7-7 12-18 14-30a47 47 0 0 0-38-55h-8a47 47 0 0 0-93-1 47 47 0 0 0-29 84z m4-41a27 27 0 0 1 32-22h1l12 2v-12a28 28 0 0 1 0-6 27 27 0 0 1 54 7v14l13-3h12a27 27 0 0 1 22 32c-4 22-15 25-24 24h-2c-43 0-71 0-95-1h-11v-2l-3-2a27 27 0 0 1-11-31z"
            fill="#5546CB" />
        <path
            d="M150 362l3 2h69c4 1 6-1 7-2s4-6 5-11a15 15 0 0 0-12-17h-7l-13 3v-11a15 15 0 0 0-30-4 15 15 0 0 0 0 3v12l-13-2a15 15 0 0 0-11 27z"
            fill="#FFFFFF" />
        <path
            d="M135 376c4 8 15 9 20 9h68c15 0 26-11 30-30a35 35 0 0 0-28-40h-3a35 35 0 0 0-67-1 35 35 0 0 0-19 61z m8-29a15 15 0 0 1 17-12l13 2v-12a15 15 0 0 1 0-3 15 15 0 0 1 30 4v14l13-3h7a15 15 0 0 1 12 17c-1 5-3 9-5 11s-3 3-7 2h-70l-3-2a15 15 0 0 1-6-18z"
            fill="#5546CB" />
        <path
            d="M636 488c-22-73-63-138-124-192l-2-2h-4c-70-5-144 24-209 82S170 534 135 650c334 101 517 146 561 155l-8-52c-12-86-25-176-52-265z m-64 209l-2 11-324-94 4-10c25-71 51-114 82-140s83-38 143-23c4 1 47 11 77 58s38 114 20 198z"
            fill="#FF8859" />
        <path
            d="M734 401c-52-43-113-75-182-95 49 51 83 110 103 175 27 91 40 181 52 268l5 32 5-9c20-42 37-75 68-106s44-37 64-50l29-19c-37-81-85-146-144-196z"
            fill="#FDCD60" />
        <path
            d="M899 596c-38-87-89-157-152-210s-131-85-212-105c-9-5-18-8-26-8-76-5-155 25-224 87S149 530 114 654l-3 9 9 3c367 111 557 158 581 161h2l8-3a10 10 0 0 0 5-5l19-38c20-42 35-72 64-101s41-35 61-48l36-25a10 10 0 0 0 3-11z m-764 54c34-117 90-212 162-275s139-86 209-82h4l2 2c60 54 102 119 124 192 27 90 39 179 52 265l8 52c-44-8-227-53-561-154z m713-34c-20 13-37 24-64 50s-48 64-68 106l-5 9-5-32c-12-87-25-177-52-268-19-65-54-124-103-175 69 20 130 51 182 95s108 115 145 196z"
            fill="#5546CB" />
        <path
            d="M345 479c-27 23-50 60-72 122l119 34 58-179c-44-7-78 1-105 23zM471 461h-1l-59 180 144 41c8-43 9-81 3-113s-15-51-30-69c-26-32-57-39-57-39z"
            fill="#FFFFFF" />
        <path
            d="M475 441c-60-15-106-8-143 23s-57 69-82 140l-4 10 324 93 2-11c18-84 11-150-20-198s-73-56-77-57zM272 601c23-61 45-99 72-122s61-30 105-23l-58 179z m282 81l-143-41 59-180h1s32 7 57 39c15 18 25 42 30 69s5 70-3 113z"
            fill="#5546CB" />
    </svg>
</template>